/**
 * 給与テキストを給与額と給与種別に分割
 *
 * @param salaryText
 * @return {{salaryAmount: string, salaryType: string}}
 */
export const splitSalaryText = (salaryText) => {
    if (!salaryText) return {salaryAmount: '', salaryType: ''};
    let salaryAmount;

    // "$101,970 - $113,300 a year" 等の形式から "$101,970 - $113,300" の部分を取得
    const salaryRangeMatch = salaryText.match(/[$|€][0-9,.]+ - [$|€][0-9,.]+/);
    salaryAmount = salaryRangeMatch ? salaryRangeMatch[0] : '';

    // 給与額が片方しかない場合
    if (salaryAmount === '') {
        // "Up to " や "From " が付いている場合は給与額と一緒に取得
        const salaryAmountMatch = salaryText.match(/(?:Up to|From|Bis zu|Ab)?\s*[$|€][0-9,.]+/);
        salaryAmount = salaryAmountMatch ? salaryAmountMatch[0] : '';
    }

    // salaryType は salaryText から salaryAmount を取り除いて前後の空白を取り除いたもの
    const salaryType = salaryText.replace(salaryAmount, '').trim();

    return {salaryAmount: salaryAmount, salaryType: salaryType};
}
